import React from "react";
import health from "../../assets/Products-icon/Raiden_verse/Digital-Twin&-Simulation/Healthcare_Simulation.svg";
import manufacute from "../../assets/Products-icon/Raiden_verse/Digital-Twin&-Simulation/Manufacturing_Optimization.svg";
import urban from "../../assets/Products-icon/Raiden_verse/Digital-Twin&-Simulation/Urban_Planning.svg";

import telepresence from "../../assets/Products-icon/Raiden_verse/Metaverse-Application/Telepresence.svg";
import Virtual_Event from "../../assets/Products-icon/Raiden_verse/Metaverse-Application/Virtual_Event.svg";
import Virtual_Training from "../../assets/Products-icon/Raiden_verse/Metaverse-Application/Virtual_Training.svg";

import brand from "../../assets/Products-icon/Raiden_verse/Metaverse-Game/Brand_Engagement.svg";
import Educational_Gaming from "../../assets/Products-icon/Raiden_verse/Metaverse-Game/Educational_Gaming.svg";
import Entertainment_Industry from "../../assets/Products-icon/Raiden_verse/Metaverse-Game/Entertainment_Industry.svg";
const ProductsCore = () => {
  return (
    <div>
      <div
        className="fancy-feature-twentyFive lg-container pt-80 padt  "
        id="features"
      >
        <div className="container">
          <div className="block-style-twentyFive  ">
            <div className="row align-items-center">
              <div
                className="col-xl-7 col-lg-6 col-md-10 m-auto text-center text-lg-right order-lg-last"
                data-aos="fade-left"
                data-aos-duration="1200"
              >
                <div className="screen-container">
                  <img
                    src="images/shape/bg6.svg"
                    alt="shape"
                    className="ms-auto bg-round-shape"
                  />
                  <div className="block-content">
                    <div className="row align-items-center">
                      <div className="col-sm-6">
                        <div className="feature-meta">
                          <div className="icon d-flex align-items-end">
                            <img
                              src={Entertainment_Industry}
                              alt="Entertainment_Industry"
                              className="icon-8"
                            />
                          </div>
                          <h3 className=" h3-heading mt-2 fw-semibold text-center">
                            Entertainment Industry
                          </h3>
                        </div>
                      </div>

                      <div className="col-sm-6">
                        <div className="feature-meta">
                          <div className="icon d-flex align-items-end">
                            <img
                              src={Educational_Gaming}
                              alt="Educational_Gaming"
                              className="icon-8"
                            />
                          </div>
                          <h3 className=" h3-heading mt-2 fw-semibold text-center">
                            Brand Engagement
                          </h3>
                        </div>
                        {/* /.feature-meta */}
                        <div className="feature-meta">
                          <div className="icon d-flex align-items-end">
                            <img src={brand} alt="brand" className="icon-8" />
                          </div>
                          <h3 className=" h3-heading mt-2 fw-semibold text-center">
                            Educational Gaming
                          </h3>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="col-xl-5 col-lg-6"
                data-aos="fade-right"
                data-aos-duration="1200"
              >
                <div className="text-wrapper order-lg-first padt">
                  <h2 className="h2-heading ">Metaverse Game </h2>
                  <p className="mt-3 lh-base h1-para" style={{ fontSize: 18 }}>
                    {" "}
                    Raiden specializes in creating VR/AR games, PCs, and
                    consoles. We provide a powerful multiplayer environment
                    integrating AI, NPC behavior, and dynamic content for an
                    enthusiastic experience.
                  </p>
                  {/* <ul className="fs-6 pt-3 h3-para">
                    <li>Entertainment Industry</li>
                    <li>Brand Engagement</li>
                    <li>Educational Gaming</li>
                  </ul> */}
                </div>
                {/*  /.text-wrapper */}
              </div>
            </div>
          </div>
          {/* /.block-style-twentyFive */}
        </div>
      </div>

      {/* How It Works  */}
      <div
        className="fancy-feature-twentyFive lg-container pt-80 padt  "
        id="features"
      >
        <div className="container">
          <div className="block-style-twentyFive  ">
            <div className="row align-items-center reverse">
              <div
                className="col-xl-7 col-lg-6 col-md-10 m-auto text-center text-lg-right order-lg-last "
                data-aos="fade-left"
                data-aos-duration="1200"
              >
                <div className="screen-container">
                  <img
                    src="images/shape/bg6.svg"
                    alt="shape"
                    className="ms-auto bg-round-shape  flex-row-reverse"
                  />
                  <div className="block-content ">
                    <div className="row align-items-center ">
                      <div className="col-sm-6">
                        <div className="feature-meta">
                          <div className="icon d-flex align-items-end">
                            <img
                              src={telepresence}
                              alt="telepresence"
                              className="icon-8"
                            />
                          </div>
                          <h3 className=" h3-heading mt-2 fw-semibold text-center">
                            Telepresence Solutions
                          </h3>
                        </div>
                      </div>

                      <div className="col-sm-6">
                        <div className="feature-meta">
                          <div className="icon d-flex align-items-end">
                            <img
                              src={Virtual_Event}
                              alt="Virtual_Event"
                              className="icon-8"
                            />
                          </div>
                          <h3 className=" h3-heading mt-2 fw-semibold text-center">
                            Virtual Events
                          </h3>
                        </div>

                        <div className="feature-meta">
                          <div className="icon d-flex align-items-end">
                            <img
                              src={Virtual_Training}
                              alt="Virtual_Training"
                              className="icon-8"
                            />
                          </div>
                          <h3 className=" h3-heading mt-2 fw-semibold text-center">
                            Virtual Training
                          </h3>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="col-xl-5 col-lg-6"
                data-aos="fade-right"
                data-aos-duration="1200"
              >
                <div className="text-wrapper order-lg-first padt">
                  <h2 className="h2-heading ">Metaverse Application</h2>
                  <p className="mt-3 lh-base h1-para" style={{ fontSize: 18 }}>
                    {" "}
                    We create flexible desktop, mobile, and VR/AR apps. Our
                    skills include using cloud services for collaboration and
                    data, as well as integrating AI features like sentiment
                    analysis, computer vision, and language processing.
                  </p>
                  {/* <ul className="fs-6 pt-3 h3-para">
                    <li>Virtual Events</li>
                    <li>Virtual Training</li>
                    <li>Telepresence Solutions</li>
                  </ul> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* How It Works  */}
      <div
        className="fancy-feature-twentyFive lg-container pt-80 padt  "
        id="features"
      >
        <div className="container">
          <div className="block-style-twentyFive  ">
            <div className="row align-items-center">
              <div
                className="col-xl-7 col-lg-6 col-md-10 m-auto text-center text-lg-right order-lg-last"
                data-aos="fade-left"
                data-aos-duration="1200"
              >
                <div className="screen-container">
                  <img
                    src="images/shape/bg6.svg"
                    alt="shape"
                    className="ms-auto bg-round-shape"
                  />
                  <div className="block-content">
                    <div className="row align-items-center">
                      <div className="col-sm-6">
                        <div className="feature-meta">
                          <div className="icon d-flex align-items-end">
                            <img src={manufacute} alt="" className="icon-8" />
                          </div>
                          <h3 className=" h3-heading mt-2 fw-semibold text-center">
                            Manufacturing Optimization
                          </h3>
                        </div>
                      </div>

                      <div className="col-sm-6">
                        <div className="feature-meta">
                          <div className="icon d-flex align-items-end">
                            <img src={health} alt="health" className="icon-8" />
                          </div>
                          <h3 className=" h3-heading mt-2 fw-semibold text-center">
                            Healthcare Simulation
                          </h3>
                        </div>

                        <div className="feature-meta">
                          <div className="icon d-flex align-items-end">
                            <img src={urban} alt="urban" className="icon-8" />
                          </div>
                          <h3 className=" h3-heading mt-2 fw-semibold text-center">
                            Urban Planning
                          </h3>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="col-xl-5 col-lg-6"
                data-aos="fade-right"
                data-aos-duration="1200"
              >
                <div className="text-wrapper order-lg-first padt">
                  <h2 className="h2-heading ">Digital Twin & Simulation</h2>
                  <p className="mt-3 lh-base h1-para" style={{ fontSize: 18 }}>
                    {" "}
                    We use simulation and 3D to create digital copies of
                    real-world objects, settings, and procedures. Real-time
                    virtual testing for operational optimization is made
                    possible by these, which combine IoT, analytics, and AI to
                    provide live, predictive insights.
                  </p>
                  {/* <ul className="fs-6 pt-3 h3-para">
                    <li>Manufacturing Optimization</li>
                    <li>Urban Planning</li>
                    <li>Healthcare Simulation</li>
                  </ul> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductsCore;
